
import React from 'react'
import Page from '../components/Page';

const PrivacyPolicy = () => (
  <Page title="Privacy Policy" padding>
    <h2>Privacy Policy</h2>
    <p><em>Last updated: March 2026</em></p>

    <h3>Data We Collect</h3>
    <p>
      This app uses <strong>Google AdMob</strong> to display advertisements. AdMob may collect device identifiers and usage data to serve personalized ads. On iOS, the app requests your permission for tracking via the App Tracking Transparency prompt before any personalized ads are shown.
    </p>
    <p>
      No personal data is collected or transmitted by us directly.
    </p>

    <h3>Data Stored on Your Device</h3>
    <p>
      Your favorites, Holy Grail progress, and mule inventories are stored locally on your device using your browser's local storage. This data never leaves your device and is not accessible to us.
    </p>

    <h3>Third-Party Services</h3>
    <p>
      Google AdMob has its own privacy policy. You can learn more at{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
        policies.google.com/privacy
      </a>.
    </p>

    <h3>Contact</h3>
    <p>
      If you have any questions about this privacy policy, feel free to{' '}
      <a href="mailto:luca@naterop.net">reach out</a>.
    </p>
  </Page>
);

export default PrivacyPolicy;
